import { render } from "./CalendarInfobar.vue?vue&type=template&id=4a766afa&scoped=true"
import script from "./CalendarInfobar.vue?vue&type=script&lang=js"
export * from "./CalendarInfobar.vue?vue&type=script&lang=js"

import "./CalendarInfobar.vue?vue&type=style&index=0&id=4a766afa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a766afa"]])

export default __exports__